module.exports = __webpack_public_path__ + "fonts/Brygada_1918-400-cyrillic2.6f68d07.woff2";